import { Pipe, PipeTransform } from '@angular/core';
import { OrderData, Quote } from '@zero/shared/util-models';
import { CombinedFractionalOrderValuePipe } from './combined-fractional-order-value.pipe';
import { CombinedMarketOrderValuePipe } from './combined-market-order-value.pipe';

@Pipe({
  name: 'combinedOrderSum',
  standalone: true,
})
export class CombinedOrderSumPipe implements PipeTransform {
  public transform(marketOrder: OrderData, fractionalOrder: OrderData, quote: Quote): number {
    const marketOrderValue = new CombinedMarketOrderValuePipe().transform(marketOrder, quote);
    const fractionalOrderValue = new CombinedFractionalOrderValuePipe().transform(fractionalOrder, quote);
    const isBuy = marketOrder.direction === 'buy';
    let surcharge = 0;
    if (fractionalOrder?.fractionalSurcharge) {
      surcharge = isBuy ? fractionalOrder.fractionalSurcharge : -fractionalOrder.fractionalSurcharge;
    }
    return marketOrderValue + fractionalOrderValue + surcharge;
  }
}
